import { useEffect, useState } from 'react';
import { EyeNoneIcon } from '@radix-ui/react-icons';
import { Button } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';
import { pushEvent } from 'helpers/crmUtils';
import Analytics from 'ui/design-base/Analytics';

export const AdBlockModal: React.FC = () => {
  useEffect(() => {
    Analytics.sendEvent({
      category: 'TT Club',
      action: 'Adblocker popup displayed',
      label: 'Adblocker Alert',
    });
    pushEvent('TT - EVENT - adblocker detected');
  }, []);
  const [disableAdBlockerMode, setDisableAdBlockerMode] = useState(false);

  const navigate = useNavigate();

  const disableAdblockClickFn = () => {
    Analytics.sendEvent({
      category: 'TT Club',
      action: 'Disable Adblocker clicked',
      label: 'Disable Adblocker Button',
    });
    disableAdBlockerMode && window.location.reload();
    setDisableAdBlockerMode(true);
  };

  const title = disableAdBlockerMode ? "Controlla l'estensione installata" : 'Adblocker rilevato';
  const description = disableAdBlockerMode
    ? 'Segui questi passi:'
    : 'Abbiamo notato che stai usando uno strumento che blocca gli annunci pubblicitari';
  const errorContent = disableAdBlockerMode ? (
    <>
      <ol>
        <li>
          Fai clic sull'icona di AdBlock nell'area delle estensioni del browser, in alto a destra dello schermo. L'icona
          potrebbe essere coperta in parte da un numero.
        </li>
        <li>
          Seleziona <b>Non eseguire su pagine di questo sito.</b>
        </li>
        <li>
          Nella finestra di dialogo &quot;Non eseguire AdBlock su…&quot;, seleziona <b>Escludi</b>. L'icona di AdBlock
          cambia e diventa un pollice rivolto verso l'alto
        </li>
      </ol>
    </>
  ) : (
    <>
      La pubblicità ci permette di offrirti ogni giorno un servizio di qualità. Se sei un nostro fan attiva la
      TennisTalker Club Membership per rimuovere tutte le pubblicità invasive e i popup. Altrimenti, disattiva il tuo Ad
      Blocker!
    </>
  );
  const firstButtonText = disableAdBlockerMode ? 'Ricarica la pagina' : 'Disattiva AdBlocker';

  const content = (
    <div
      id='container'
      className='border-neutral-neutral-3 bg-neutral-neutral-1 mt-4 flex max-w-80 flex-col items-start gap-4 self-stretch rounded-2xl border border-solid p-3'
    >
      <div id='error' className='flex flex-col items-start gap-4 self-stretch'>
        <div className='flex items-center gap-2 self-stretch'>
          <div id='icon' className='flex h-8 w-8 gap-2 fill-transparent'>
            <EyeNoneIcon width='32' height='32' color='#E2A336' />
          </div>
          <div className='text-neutral-neutral-12 text-sm font-medium'>{title}</div>
        </div>
        <div className='text-neutral-neutral-12 text-lg leading-6 font-bold'>{description}</div>
        <div className='text-neutral-neutral-12 text-sm font-normal'>{errorContent}</div>
      </div>
      <div id='separator' className='bg-neutral-neutral-4 flex h-px self-stretch'></div>
      <div id='back' className='flex w-full items-center justify-between gap-4'>
        <div id='text'>
          <Button size='2' variant='soft' color='gray' onClick={disableAdblockClickFn}>
            {firstButtonText}
          </Button>
        </div>
        <div id='back'>
          <Button size='2' variant='soft' color='lime' onClick={() => navigate('/club-membership')}>
            Scopri TTClub
          </Button>
        </div>
      </div>
    </div>
  );
  return content;
};

export default AdBlockModal;
